"use client"

import { LayoutList } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LayoutListIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LayoutListIcon = component(Icon)({ as: LayoutList })
